import { StringIdentifierSerializer } from './string-identifier-serializer';

export function stringIdentifierBase64Serializer<ExtendedType extends string = string>(
    extraConversion?: (parsed: string) => ExtendedType,
): StringIdentifierSerializer<ExtendedType> {
    return {
        deserialize(stringVal) {
            const decrypted = Buffer.from(stringVal, 'base64').toString();
            if (extraConversion) {
                return extraConversion(decrypted);
            }
            return decrypted as ExtendedType;
        },
        serialize(val) {
            return Buffer.from(val).toString('base64');
        },
    };
}
